import { Link, Navigate, useParams } from "react-router-dom";
import {
  AGENT_TEMPLATES,
  CONCIERGE,
  INSTANCES,
  INTEGRATIONS_FIXTURE,
  OWNER,
} from "./mock";
import { AgentTemplatesSection } from "./sections/AgentTemplates";
import { InstanceHero } from "./sections/InstanceHero";
import { InstanceSwitcher } from "./sections/InstanceSwitcher";
import { IntegrationsSection } from "./sections/Integrations";
import { OnboardingSection } from "./sections/Onboarding";
import { ResourcesSection } from "./sections/Resources";
import styles from "./DashboardSectionPreview.module.css";

const SECTION_LABELS: Record<string, string> = {
  onboarding: "Onboarding",
  "instance-switcher": "Instance switcher",
  "instance-hero": "Instance hero",
  integrations: "Integrations",
  "agent-templates": "Agent templates",
  resources: "Resources",
};

const renderSection = (slug: string): JSX.Element | null => {
  const primary = INSTANCES[0];
  if (!primary) return null;
  switch (slug) {
    case "onboarding":
      return <OnboardingSection owner={OWNER} />;
    case "instance-switcher":
      return (
        <InstanceSwitcher
          instances={INSTANCES}
          currentInstanceId={primary.id}
        />
      );
    case "instance-hero":
      return (
        <InstanceHero
          instance={primary}
          spend={null}
          concierge={CONCIERGE}
          activeIntegrations={INTEGRATIONS_FIXTURE.filter(
            (i) => i.status === "active" || i.status === "provisioning",
          )}
          requiredApps={[]}
          requiredAppsResolved
        />
      );
    case "integrations":
      return <IntegrationsSection integrations={INTEGRATIONS_FIXTURE} />;
    case "agent-templates":
      return <AgentTemplatesSection templates={AGENT_TEMPLATES} />;
    case "resources":
      return <ResourcesSection />;
    default:
      return null;
  }
};

export const DashboardSectionPreview = (): JSX.Element => {
  const { section } = useParams<{ section: string }>();
  const label = section ? SECTION_LABELS[section] : undefined;
  const node = section ? renderSection(section) : null;

  if (!label || !node) {
    return <Navigate to="/dashboard/overview" replace />;
  }

  return (
    <div className={styles.frame}>
      <div className={styles.eyebrow}>
        <span className={styles.eyebrowLabel}>
          <span className={styles.dot} aria-hidden /> Section preview · {label}
        </span>
        <Link to="/dashboard/overview" className={styles.back}>
          ← back to dashboard
        </Link>
      </div>
      {node}
    </div>
  );
};
